export const URL_CONST = {
  dashboard: {
    home: '/dashboard',
    mitigation: '/dashboard/mitigation',
    mitigationList: '/dashboard/mitigation/list',
    awareness: '/dashboard/awareness',
    visualDetection: '/dashboard/visual',
    ade: '/dashboard/ade',
  },
  incidents: {
    self: '/irontraps',
    incidents: '/irontraps/incidents',
    unclassified: '/irontraps/incidents/unclassified',
    classified: '/irontraps/incidents/classified',
    attackdetails: '/irontraps/attackdetails',
    remediated: '/irontraps/history/remediations',
    reported: '/irontraps/history/reported-incidents',
    scanbackOverview: '/irontraps/scanback/overview',
    scanback: '/irontraps/incidents/scanback',
    challenged: '/irontraps/incidents/challenged',
    serverscan: '/irontraps/serverscan',
    partners: '/partners/irontraps',
  },
  awarenessCenter: {
    self: '/awareness-center',
    campaigns: '/awareness-center/campaigns',
    scenarios: '/awareness-center/scenarios',
    callforaction: '/awareness-center/call-for-action',
    landingpage: '/awareness-center/landing-pages',
    report: '/awareness-center/report',
    wizardCampaign: '/awareness-center/wizard-campaign',
    wizardCampaignPartnerCompany: '/company',
    wizardCampaignCampaignSetup: '/campaign-setup',
    wizardCampaignGenerateEmails: '/generate-emails',
    wizardCampaignCampaignMessage: '/message',
    wizardCampaignScenarios: '/scenarios',
    wizardCampaignLandingPage: '/landing-page',
    wizardCampaignTrainingModule: '/training-module',
    wizardCampaignReviewLaunch: '/review-launch',
  },
  mailboxes: {
    self: '/mailboxes',
    management: '/mailboxes/management',
    upload: '/mailboxes/upload',
    segments: '/mailboxes/segments',
    userReport: '/mailboxes/user-report',
    vipuser: '/mailboxes/management/vipuser',
  },
  dmarc: {
    self: '/dmarc',
  },
  settings: {
    self: '/settings',
    profile: '/settings/account/profile',
    general: '/settings/account/general',
    permissions: '/settings/account/users',
    languages: '/settings/account/languages',
    incidence: '/settings/threats/incident',
    community: '/settings/threats/intelligence',
    impersonation: '/settings/threats/protection',
    customization: '/settings/threats/customization',
    customizationO365: '/settings/threats/customization/o365',
    allowlist: '/settings/threats/allowlist',
    microsoftQuarantine: '/settings/threats/microsoft-quarantine',
    simulator: '/settings/simulator',
    ignoreIpRange: '/settings/ignore-ip-range',
    emailServer: '/settings/integrations/email-server',
    malware: '/settings/integrations/malware',
    alerts: '/settings/integrations/alerts',
    collaborationApps: '/settings/notifications/collaboration-apps',
    systemAlerts: '/settings/notifications/system',
    endUserAlerts: '/settings/notifications/enduser',
    disclaimers: '/settings/disclaimers',
    partner: '/settings/partner',
    deepFakeGeneral: '/settings/deepfake/general',
  },
  groupSettings: {
    self: '/group-settings',
    wizard: '/group-settings/wizard',
    assign: '/group-settings/assign',
  },
  login: {
    signin: '/signin',
    signout: '/signout',
    resetToken: '/signin/reset/token/',
    resetPassword: '/signin/reset/password/',
  },
  partners: { self: '/partners' },
  activities: { self: '/activities' },
  resources: { self: '/resources' },
  kpi: { self: '/kpi' },
  investigation: {
    threatLog: '/threat-activity',
    ato: '/threat-activity/account-investigation',
  },
  staticDemo: { self: '/sales-demo/create-static' },
}
